import { TRIP_STATUS_MAP } from '@returnmates/client-core/src/constants/trip'
import {
  TripCxlReasonType,
  TripFailureReasonType,
  TripStatus,
  TripSuccessReasonType,
  TripType,
} from '@returnmates/client-core/src/graphql/generated/api'

import { FilterPanelType, TableColumn } from '../../components/GridTable/types'

export const columnsGrid: TableColumn[] = [
  {
    name: 'status',
    title: 'Status',
    filterable: true,
    filterPanelType: FilterPanelType.RADIO_GROUP,
    filterRadioOptions: TRIP_STATUS_MAP,
    searchable: false,
    sortingEnabled: true,
    width: 200,
  },
  {
    name: 'date',
    title: 'Date',
    filterable: false,
    searchable: false,
    sortingEnabled: true,
    width: 150,
  },
  {
    name: 'displayType',
    title: 'Type',
    filterable: false,
    searchable: false,
    width: 'auto',
  },
  {
    name: 'name',
    title: 'Name',
    filterable: true,
    searchable: true,
    sortingEnabled: true,
    width: 'auto',
  },
  {
    name: 'street',
    title: 'Street',
    filterable: true,
    searchable: true,
    sortingEnabled: true,
    width: 'auto',
  },
  {
    name: 'phone',
    title: 'Phone',
    filterable: true,
    searchable: true,
    sortingEnabled: true,
    width: 150,
  },
  {
    name: 'trackingLink',
    title: ' ',
    filterable: false,
    searchable: false,
    sortingEnabled: false,
    align: 'center',
    width: 80,
  },
  {
    name: 'trackingCopyLink',
    title: ' ',
    filterable: false,
    searchable: false,
    sortingEnabled: false,
    align: 'center',
    width: 80,
  },
]

export const defaultTripColumnWidths = columnsGrid.map(col => ({
  columnName: col.name,
  width: col.width,
}))

export const checkboxFilter = {
  type: 'status',
  values: [
    { key: TripStatus.PENDING, label: 'Pending' },
    { key: TripStatus.PENDING_API, label: 'Pending (API)' },
    { key: TripStatus.SCHEDULED, label: 'Scheduled' },
    { key: TripStatus.DRIVER_LAUNCHED, label: 'Driver Launched' },
    { key: TripStatus.IN_PROGRESS, label: 'In Progress' },
    { key: TripStatus.COMPLETE, label: 'Complete' },
    { key: TripStatus.FAILED, label: 'Failed' },
    { key: TripStatus.CANCELED, label: 'Canceled' },
    { key: TripStatus.TASK_NOT_CREATED, label: 'Task Not Created' },
    { key: TripStatus.NO_LOCATION, label: 'No Location' },
  ],
}

export const enabledStatusesObj = {
  [TripStatus.TASK_NOT_CREATED]: [
    TripStatus.TASK_NOT_CREATED,
    TripStatus.CANCELED,
    TripStatus.COMPLETE,
  ],
  [TripStatus.PENDING]: [TripStatus.PENDING, TripStatus.CANCELED],
  [TripStatus.PENDING_API]: [TripStatus.PENDING_API],
  [TripStatus.SCHEDULED]: [TripStatus.SCHEDULED, TripStatus.CANCELED],
  [TripStatus.DRIVER_LAUNCHED]: [TripStatus.DRIVER_LAUNCHED, TripStatus.CANCELED],
  [TripStatus.IN_PROGRESS]: [TripStatus.IN_PROGRESS, TripStatus.CANCELED],
  [TripStatus.NO_LOCATION]: [TripStatus.NO_LOCATION, TripStatus.CANCELED],
  [TripStatus.CANCELED]: [TripStatus.CANCELED, TripStatus.COMPLETE],
  [TripStatus.COMPLETE]: [TripStatus.COMPLETE, TripStatus.FAILED, TripStatus.CANCELED],
  [TripStatus.FAILED]: [TripStatus.FAILED, TripStatus.CANCELED, TripStatus.COMPLETE],
}

export const tableColumnExtensions = [
  { columnName: 'phone', width: 150 },
  { columnName: 'date', width: 150 },
  { columnName: 'status', width: 200 },
  { columnName: 'trackingLink', width: 80 },
  { columnName: 'trackingCopyLink', width: 80 },
]

export const formattedColumnNames = ['status', 'trackingLink', 'trackingCopyLink']
export const formattedColumns = ['phone']

export const dateLabelMap = {
  [TripType.DROPOFF]: 'Delivery',
  [TripType.PICKUP]: 'Pickup',
}

export const undersCheckboxValue = {
  key: 'Unders',
  label: 'Unders',
}

export const sortDescByName = ['date']

export const scheduleOnFleetStatuses = [
  TripStatus.CANCELED,
  TripStatus.FAILED,
  TripStatus.TASK_NOT_CREATED,
]

export const FAILURE_REASONS = {
  [TripFailureReasonType.ACCESS_FAILURE]: 'Access failure',
  [TripFailureReasonType.BUSINESS_CLOSED]: 'Business Closed',
  [TripFailureReasonType.APARTMENT_CLOSED]: 'Apartment Closed',
  [TripFailureReasonType.NO_PACKAGE_FROM_CUSTOMER]: 'No package from customer',
  [TripFailureReasonType.UNABLE_DUE_TO_WEATHER]: 'Unable due to weather',
  [TripFailureReasonType.DUPLICATE]: 'Duplicate',
  [TripFailureReasonType.CUSTOMER_UNAVAILABLE]: 'Customer unavailable',
  [TripFailureReasonType.DRIVER_EMERGENCY]: 'Driver emergency',
  [TripFailureReasonType.ROADBLOCK]: 'Roadblock',
  [TripFailureReasonType.PACKAGE_NOT_IN_VEHICLE]: 'Package not in vehicle',
  [TripFailureReasonType.PACKAGE_SIZE]: 'Package size',
  [TripFailureReasonType.INSUFFICIENT_PACKAGING]: 'Insufficient packaging',
  [TripFailureReasonType.OTHER_CARRIER_PICKED_UP]: 'Other carrier picked up',
  [TripFailureReasonType.PACKAGE_STOLEN]: 'Package was stolen',
  [TripFailureReasonType.SIGNATURE_REQUIRED]: 'Signature Required',
  [TripFailureReasonType.OTHER]: 'Other / Unknown',
}

export const SUCCESS_REASONS = {
  [TripSuccessReasonType.ALL_CUSTOMER_INSTRUCTIONS_FOLLOWED]: 'All Customer Instructions Followed',
  [TripSuccessReasonType.NO_CUSTOMER_INSTRUCTIONS_PROVIDED]: 'No Customer Instructions Provided',
  [TripSuccessReasonType.UNABLE_TO_FOLLOW_CUSTOMER_INSTRUCTIONS]:
    'Unable to Follow Customer Instructions',
  [TripSuccessReasonType.DEFAULT]: 'No Success Criteria Found',
}

export const searchFields = [
  { key: 'addressName', label: 'Name' },
  { key: 'addressStreet', label: 'Street' },
  { key: 'addressPhone', label: 'Phone' },
  { key: 'tripId', label: 'ID' },
  { key: 'trackingId', label: 'Package Tracking ID' },
  { key: 'packageId', label: 'Package Id' },
  { key: 'userEmail', label: 'Email' },
]

export const TRIP_CANCELLATION_REASONS: Partial<Record<TripCxlReasonType, string>> = {
  [TripCxlReasonType.DUPLICATE]: 'Duplicate',
  [TripCxlReasonType.ONFLEET_DELETION]: 'Onfleet Deletion',
  [TripCxlReasonType.ORDER_CANCELLED]: 'Order Cancelled',
  [TripCxlReasonType.RTS_PARTNER]: 'Rts Partner',
  [TripCxlReasonType.RTS_UNDELIVERABLE]: 'Rts Undeliverable',
  [TripCxlReasonType.SCHEDULING_ISSUE]: 'Scheduling Issue',
  [TripCxlReasonType.SIZE_LIMIT]: 'Size Limit',
  [TripCxlReasonType.UNDER]: 'Under',
  [TripCxlReasonType.UNKNOWN]: 'Unknown',
  [TripCxlReasonType.MANIFESTED_BUT_NOT_RECEIVED]: 'Manifested But Not Received',
  [TripCxlReasonType.RESCHEDULE]: 'Rescheduled to another trip',
  [TripCxlReasonType.NOT_READY]: 'Not ready for the pickup',
  [TripCxlReasonType.CUSTOMER_SHIPPED]: 'I shipped it myself',
  [TripCxlReasonType.KEPT_ITEM]: 'I chose to keep it',
  [TripCxlReasonType.LATE_ORDER]: 'Item was arriving too late',
  [TripCxlReasonType.ALREADY_RECEIVED]: 'I already received this shipment',
  [TripCxlReasonType.MEMBERSHIP_CANCELLED]: 'I canceled my membership',
}

export const TRIP_CANCELLATION_DISABLED_REASONS = [
  TripCxlReasonType.NOT_READY,
  TripCxlReasonType.CUSTOMER_SHIPPED,
  TripCxlReasonType.KEPT_ITEM,
  TripCxlReasonType.LATE_ORDER,
  TripCxlReasonType.ALREADY_RECEIVED,
  TripCxlReasonType.MEMBERSHIP_CANCELLED,
]

export const statusesForCompletionNotes = [
  TripStatus.CANCELED,
  TripStatus.FAILED,
  TripStatus.COMPLETE,
]

export const CSATScoreMap = {
  0: 'None',
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
}
